// Minimal API calls using your axiosInstance
import { axiosInstance } from "../apiConfig";

export const eligibilityCall = async (systemName, authToken) => {
  const { data } = await axiosInstance.post("/api/exit/eligibility", {
    systemName,
    authToken,
  });
  return data; // { eligible: boolean, reason?: string }
};

export const statusCall = async (systemName, authToken, resumeToken) => {
  const { data } = await axiosInstance.post("/api/exit/status", {
    systemName,
    authToken,
    ...(resumeToken ? { resumeToken } : {}),
  });
  return data; // { state, resumeToken?, ... }
};

export const initiateExitCall = async (systemName, authToken, resumeToken) => {
  const { data } = await axiosInstance.post("/api/exit/initiate", {
    systemName,
    authToken,
    ...(resumeToken ? { resumeToken } : {}),
    confirmOneWayDoor: true,
  });
  return data; // { state: 'initiated', resumeToken, coinManifest? }
};

export const montageCompleteCall = async (
  systemName,
  authToken,
  resumeToken
) => {
  const { data } = await axiosInstance.post(`/api/exit/montage-complete`, {
    systemName,
    authToken,
    ...(resumeToken ? { resumeToken } : {}),
  });
  return data;
};

export const detailsCall = async (
  systemName,
  authToken,
  resumeToken,
  { name, email, linkedin }
) => {
  const { data } = await axiosInstance.post(`/api/exit/details`, {
    systemName,
    authToken,
    ...(resumeToken ? { resumeToken } : {}),
    name,
    email,
    linkedin,
  });
  return data;
};

export const checkIsRevealReady = async (
  systemName,
  authToken,
  resumeToken
) => {
  const { data } = await axiosInstance.post(`/api/exit/reveal`, {
    systemName,
    authToken,
    ...(resumeToken ? { resumeToken } : {}),
  });
  return data;
};

export const revealCompleteCall = async (
  systemName,
  authToken,
  resumeToken
) => {
  const { data } = await axiosInstance.post(`/api/exit/reveal-complete`, {
    systemName,
    authToken,
    ...(resumeToken ? { resumeToken } : {}),
  });
  return data;
};

export const rewardCall = async (systemName, authToken, resumeToken) => {
  const { data } = await axiosInstance.post(`/api/exit/reward`, {
    systemName,
    authToken,
    ...(resumeToken ? { resumeToken } : {}),
  });
  return data; // { coins: [...], ... }
};

export const finalizeCall = async (systemName, authToken, resumeToken) => {
  const { data } = await axiosInstance.post(`/api/exit/finalize`, {
    systemName,
    authToken,
    ...(resumeToken ? { resumeToken } : {}),
  });
  return data; // { state: 'finalized' }
};
